var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructIconThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6083_12901)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.8335,
    cy: 39.5,
    r: 34.4125,
    stroke: "#314064",
    strokeWidth: 2.175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8335 68C55.5736 68 68.3335 55.2401 68.3335 39.5C68.3335 23.7599 55.5736 11 39.8335 11C24.0934 11 11.3335 23.7599 11.3335 39.5",
    stroke: "#799DD2",
    strokeWidth: 2.175,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3572 37.357C50.3335 36.3807 50.3335 34.8094 50.3335 31.6667C50.3335 28.524 50.3335 26.9526 49.3572 25.9763M49.3572 37.357C48.3809 38.3333 46.8095 38.3333 43.6668 38.3333H37.0002C33.8575 38.3333 32.2861 38.3333 31.3098 37.357M49.3572 37.357C49.3572 37.357 49.3572 37.357 49.3572 37.357ZM49.3572 25.9763C48.3809 25 46.8095 25 43.6668 25L37.0002 25C33.8575 25 32.2861 25 31.3098 25.9763M49.3572 25.9763C49.3572 25.9763 49.3572 25.9763 49.3572 25.9763ZM31.3098 25.9763C30.3335 26.9526 30.3335 28.524 30.3335 31.6667C30.3335 34.8094 30.3335 36.3807 31.3098 37.357M31.3098 25.9763C31.3098 25.9763 31.3098 25.9763 31.3098 25.9763ZM31.3098 37.357C31.3098 37.357 31.3098 37.357 31.3098 37.357Z",
    stroke: "#314064",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0003 31.6667C42.0003 32.5871 41.2541 33.3333 40.3337 33.3333C39.4132 33.3333 38.667 32.5871 38.667 31.6667C38.667 30.7462 39.4132 30 40.3337 30C41.2541 30 42.0003 30.7462 42.0003 31.6667Z",
    stroke: "#314064",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3335 30C47.5721 30 45.3335 27.7614 45.3335 25",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3335 33.3335C47.5721 33.3335 45.3335 35.5721 45.3335 38.3335",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 30C33.0949 30 35.3335 27.7614 35.3335 25",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 33.3335C33.0949 33.3335 35.3335 35.5721 35.3335 38.3335",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.667 53.9808H32.4335C34.1183 53.9808 35.8212 54.1563 37.4609 54.4941C40.3613 55.0917 43.4151 55.1641 46.3452 54.6897C47.79 54.4559 49.2104 54.0983 50.4961 53.4777C51.6568 52.9175 53.0786 52.1278 54.0335 51.2434C54.9872 50.3601 55.9803 48.9146 56.6852 47.7847C57.2897 46.8158 56.9973 45.6271 56.0412 44.9052C54.9792 44.1033 53.4032 44.1035 52.3414 44.9056L49.3294 47.1809C48.1621 48.0627 46.8869 48.8744 45.368 49.1167C45.1853 49.1458 44.9939 49.1724 44.7943 49.1955M44.7943 49.1955C44.7341 49.2025 44.6733 49.2091 44.6117 49.2154M44.7943 49.1955C45.0372 49.1434 45.2785 48.9936 45.5049 48.796C46.5769 47.8603 46.6447 46.2835 45.7146 45.2387C45.4988 44.9963 45.2462 44.7941 44.9654 44.6267C40.3032 41.8459 33.0494 43.9638 28.667 47.0717M44.7943 49.1955C44.7334 49.2085 44.6725 49.2154 44.6117 49.2154M44.6117 49.2154C43.7394 49.305 42.7189 49.3281 41.5866 49.2212",
    stroke: "#314064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.667,
    y: 43.3335,
    width: 5,
    height: 13.3333,
    rx: 1.5,
    stroke: "#314064",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6083_12901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructIconThree);
export default __webpack_public_path__ + "static/media/instructIconThree.2beef21431bcedce96f34ecff466c461.svg";
export { ForwardRef as ReactComponent };